/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useInfiniteQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useClientBookings = (params) => {
  return useInfiniteQuery({
    queryKey: queryKeys.client.bookings(params),
    queryFn: ({ pageParam = 1 }) =>
      fetcher({ method: "GET", url: "/public/booking", params: { ...params, page: pageParam, on_page: 5 } }),
    staleTime: Infinity,
    gcTime: Infinity,
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.metadata.pages_count > lastPage.metadata.page ? lastPage.metadata.page + 1 : undefined,
  });
};
